import request from '@/utils/request'
import qs from 'qs'

const api = {
	getSfxmList: '/sfxm/getSfxmList'
}

//查询收费项目
export function getSfxmList(parameter) {
    return request({
        url: api.getSfxmList,
        method: 'post',
        data: qs.stringify(parameter)
    })
}
